/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

export enum NumericPredicateOp {
	EqualTo = 'EqualTo',
	NotEqualTo = 'NotEqualTo',
	LessThan = 'LessThan',
	GreaterThan = 'GreaterThan',
	LessThanOrEqualTo = 'LessThanOrEqualTo',
	GreaterThanOrEqualTo = 'GreaterThanOrEqualTo',
	NotSet = 'NotSet',
	AnyValue = 'AnyValue',
}

export enum TextPredicateOp {
	Contains = 'Contains',
	ExactlyMatches = 'ExactlyMatches',
	NotSet = 'NotSet',
	AnyValue = 'AnyValue',
}
export enum DropDownPredicateOp {
	IsOneOf = 'IsOneOf',
	NotSet = 'NotSet',
	AnyValue = 'AnyValue',
}

export enum DatePredicateOp {
	EqualTo = 'EqualTo',
	NotEqualTo = 'NotEqualTo',
	LessThan = 'LessThan',
	GreaterThan = 'GreaterThan',
	LessThanOrEqualTo = 'LessThanOrEqualTo',
	GreaterThanOrEqualTo = 'GreaterThanOrEqualTo',
	NotSet = 'NotSet',
	AnyValue = 'AnyValue',
}

export enum CommonPredicateOp {
	EqualTo = 'EqualTo',
	NotEqualTo = 'NotEqualTo',
	NotSet = 'NotSet',
	AnyValue = 'AnyValue',
	Ignore = 'Ignore',
}

export type TpFilterPredicateOp =
	| NumericPredicateOp
	| TextPredicateOp
	| DropDownPredicateOp
	| CommonPredicateOp
	| DatePredicateOp;

export interface ITPFilterPredicateOpPair {
	key: TpFilterPredicateOp;
	label: string;
}

export interface ITPFilter {
	operator: TpFilterPredicateOp;
	value: string | number | string[] | null;
}

export interface ICustomFieldFilter extends ITPFilter {
	customFieldId?: string;
}
